export default [
    {
        path: '/autologin',
        name: 'autologin',
        component: () => import(/* webpackChunkName: "autologin" */ './Autologin.vue')
    },
        {
        path: '/sso',
        name: 'autologin',
        component: () => import(/* webpackChunkName: "autologin" */ './SingleSignOn.vue')
    },
]

